import { getReviewColors } from "../../helpers/formatters";
import {
  testgrayBackground,
  testgrayText,
  testgreenBackground,
  testgreenText,
  testRedBackground,
  testRedText,
} from "../../constants/test";
import { useEffect } from "react";
import { toast } from "react-toastify";
import styles from "./perscriptionAnswerBlock.module.scss";
function PerscriptionAnswerBlock({
  examinationState,
  setExaminationState,
  currentQuestionId,
  reviewMode,
  ShowMyAnswerMode,
  reviewData,
  prescriptionAnswerData,
  prescriptionAnswerLoading,
}) {
  useEffect(() => {
    if (
      !reviewMode &&
      !ShowMyAnswerMode &&
      currentQuestionId &&
      !examinationState?.prescriptions?.[currentQuestionId] &&
      setExaminationState
    ) {
      setExaminationState((prevState) => ({
        ...prevState,
        prescriptions: {
          ...prevState?.prescriptions,
          [currentQuestionId]: [
            {
              drug: "",
              strength: "",
              disp: 0, // Changed to integer
              sig: "",
              repeat: 0, // Changed to integer
            },
          ],
        },
      }));
    }
  }, [
    currentQuestionId,
    examinationState,
    setExaminationState,
    reviewMode,
    ShowMyAnswerMode,
  ]);

  const currentPerscription =
    examinationState?.prescriptions?.[currentQuestionId]?.[0];

  // Simplified handleInputChange function
  const handleInputChange = (field, value) => {
    if (setExaminationState) {
      setExaminationState((prevState) => ({
        ...prevState,
        prescriptions: {
          ...prevState?.prescriptions,
          [currentQuestionId]: [
            {
              ...prevState?.prescriptions?.[currentQuestionId]?.[0],
              [field]: value,
            },
          ],
        },
      }));
    }
  };

  let DrugFields = {
    Color: undefined,
    YourAnswer: undefined,
    CorrectAnswer: undefined,
    Points: undefined,
  };
  let StrengthFields = {
    Color: undefined,
    YourStrength: undefined,
    YourStrengthUnits: undefined,
    CorrectStrength: undefined,
    StrengthUnits: undefined,
    Points: undefined,
  };
  let DispFields = {
    Color: undefined,
    YourAnswer: undefined,
    CorrectAnswer: undefined,
    Points: undefined,
  };
  let RepeatFields = {
    Color: undefined,
    YourAnswer: undefined,
    CorrectAnswer: undefined,
    Points: undefined,
  };
  let SigFields = {
    Color: undefined,
    YourAnswer: undefined,
    CorrectAnswer: undefined,
    Points: undefined,
    ComponentResults: undefined,
    Feedback: undefined,
  };

  // Determine which data source to use
  const isShowAnswerMode = ShowMyAnswerMode;
  const isReviewMode = reviewMode;
  const showResults = isReviewMode;

  // Get the answer data from the passed prop
  let showAnswerData = null;
  if (
    prescriptionAnswerData?.success &&
    prescriptionAnswerData?.results?.length > 0
  ) {
    showAnswerData = prescriptionAnswerData.results[0];
    // Debug logging to check data structure
    console.log("showAnswerData:", showAnswerData);
    console.log("showAnswerData.Sig:", showAnswerData?.Sig);
  }

  if (isReviewMode) {
    console.log("Setting review fields");
    DrugFields = reviewData?.Drug || DrugFields;
    StrengthFields = reviewData?.Strength || StrengthFields;
    DispFields = reviewData?.Disp || DispFields;
    RepeatFields = reviewData?.Repeat || RepeatFields;
    SigFields = reviewData?.Sig || SigFields;
  } else if (isShowAnswerMode && showAnswerData) {
    console.log("Setting show answer fields");
    console.log("showAnswerData in assignment:", showAnswerData);
    DrugFields = showAnswerData?.Drug || DrugFields;
    StrengthFields = showAnswerData?.Strength || StrengthFields;
    DispFields = showAnswerData?.Disp || DispFields;
    RepeatFields = showAnswerData?.Repeat || RepeatFields;
    SigFields = showAnswerData?.Sig || SigFields;
    console.log("SigFields after assignment:", SigFields);
  } else {
    if (
      currentPerscription == undefined &&
      !examinationState?.viewAnswerMode &&
      !reviewMode
    ) {
      return <>...Loading</>;
    }
  }
  // Show loading state when in view answer mode and data is loading
  if (
    !reviewMode &&
    isShowAnswerMode &&
    (prescriptionAnswerLoading || !showAnswerData)
  ) {
    console.log("Waiting on answer");
    return (
      <div className={styles.block}>
        <div className={styles.centeredColumn}>
          <div className={styles.instructions}>
            <span className={styles.instructionsText}>
              Loading Answer...
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.block}>
      <div className={styles.centeredColumn}>
        <div className={styles.instructions}>
          <span className={styles.instructionsText}>
            Write a prescription for the most appropriate drug for this patient,
            using the generic name of the drug.
          </span>
        </div>
        <div className={styles.prescriptionPad}>
          <div
            className={styles.doctorHeader}
          >
            <span>DOCTOR DENTIST</span>
            <span>100 ANYWHERE STREET</span>
            <span>ANYWHERE CITY, CANADA</span>
            <span>TELEPHONE XXX-XXX-XXX</span>
          </div>
          <div className={styles.headerRow}>
            <div className={styles.headerField}>
              <span className={styles.headerLabel}>Patient Name:</span>
              <span>John Doe</span>
            </div>
            <div className={styles.dateField}>
              <span className={styles.bold}>Date:</span>
              <span> TODAY</span>
            </div>
          </div>
          <div className={styles.headerRow}>
            <div className={styles.headerField}>
              <span className={styles.headerLabel}>Address:</span>
              <span>123 Main Street, Ottawa, ON</span>
            </div>
          </div>
          <div className={styles.rxField}>
            <span className={styles.rxSymbol}>℞</span>
          </div>
          <div className={styles.field}>
            <div className={styles.fieldLabelRow}>
              <span className={styles.fieldLabel}>
                Drug:
              </span>
              {!showResults && !isShowAnswerMode && (
                <input
                  type="text"
                  id="drug"
                  name="drug"
                  className={styles.textInput}
                  value={currentPerscription?.drug || ""}
                  onChange={(e) => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      return;
                    }
                    handleInputChange("drug", e.target.value);
                  }}
                  onClick={() => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      toast(
                        "You've already viewed the answer for this question"
                      );
                    }
                  }}
                />
              )}
              {/* Review mode Drug fields */}
              {showResults &&
                DrugFields &&
                DrugFields.Color !== undefined &&
                (() => {
                  const colorObject = getReviewColors(DrugFields.Color);

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>{DrugFields?.YourAnswer || "N/A"}</span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>{DrugFields?.CorrectAnswer || "N/A"}</span>
                      </div>
                      <div
                        className={`${
                          DrugFields.Points == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          DrugFields.Points == 0 ? testRedText : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>{((DrugFields.Points || 0) / 4) * 100}%</span>
                      </div>
                    </div>
                  );
                })()}
              {/* Show Answer mode Drug fields */}
              {isShowAnswerMode &&
                showAnswerData?.Drug &&
                (() => {
                  const colorObject = getReviewColors(
                    showAnswerData.Drug.Color
                  );

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer : </span>
                        <span>{showAnswerData.Drug?.YourAnswer || "N/A"}</span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>
                          {showAnswerData.Drug?.CorrectAnswer || "N/A"}
                        </span>
                      </div>
                      <div
                        className={`${
                          (showAnswerData.Drug?.Points || 0) == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          (showAnswerData.Drug?.Points || 0) == 0
                            ? testRedText
                            : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>
                          {((showAnswerData.Drug?.Points || 0) / 4) * 100}%
                        </span>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.fieldLabelRow}>
              <span className={styles.fieldLabel}>
                Strength:
              </span>
              {!showResults && !isShowAnswerMode && (
                <input
                  type="text"
                  id="strength"
                  name="strength"
                  className={styles.textInput}
                  value={currentPerscription?.strength || ""}
                  onChange={(e) => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      return;
                    }
                    handleInputChange("strength", e.target.value);
                  }}
                  onClick={() => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      toast(
                        "You've already viewed the answer for this question"
                      );
                    }
                  }}
                />
              )}
              {/* Review mode Strength fields */}
              {showResults &&
                StrengthFields &&
                StrengthFields.Color !== undefined &&
                (() => {
                  const colorObject = getReviewColors(StrengthFields.Color);

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>
                          {StrengthFields?.YourStrength || "N/A"}{" "}
                          {StrengthFields?.YourStrengthUnits || ""}
                        </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>
                          {StrengthFields?.CorrectStrength || "N/A"}{" "}
                          {StrengthFields?.StrengthUnits || ""}
                        </span>
                      </div>
                      <div
                        className={`${
                          StrengthFields.Points == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          StrengthFields.Points == 0
                            ? testRedText
                            : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total:</span>
                        <span>{((StrengthFields.Points || 0) / 4) * 100}%</span>
                      </div>
                    </div>
                  );
                })()}
              {/* Show Answer mode Strength fields */}
              {isShowAnswerMode &&
                showAnswerData?.Strength &&
                (() => {
                  const colorObject = getReviewColors(
                    showAnswerData.Strength.Color
                  );

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>
                          {showAnswerData.Strength?.YourStrength || "N/A"}{" "}
                          {showAnswerData.Strength?.YourStrengthUnits || ""}
                        </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>
                          {showAnswerData.Strength?.CorrectStrength || "N/A"}{" "}
                          {showAnswerData.Strength?.StrengthUnits || ""}
                        </span>
                      </div>
                      <div
                        className={`${
                          (showAnswerData.Strength?.Points || 0) == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          (showAnswerData.Strength?.Points || 0) == 0
                            ? testRedText
                            : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total:</span>
                        <span>
                          {((showAnswerData.Strength?.Points || 0) / 4) * 100}%
                        </span>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.fieldLabelRow}>
              <span className={styles.fieldLabel}>
                Disp.:
              </span>
              {!showResults && !isShowAnswerMode && (
                <input
                  type="number"
                  id="disp"
                  name="disp"
                  placeholder="0"
                  min={0}
                  className={styles.numberInput}
                  value={currentPerscription?.disp || ""}
                  onChange={(e) => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      return;
                    }
                    // Convert to integer for disp field
                    const intValue =
                      e.target.value === "" ? 0 : parseInt(e.target.value, 10);
                    handleInputChange("disp", intValue);
                  }}
                  onClick={() => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      toast(
                        "You've already viewed the answer for this question"
                      );
                    }
                  }}
                />
              )}
              {/* Review mode Disp fields */}
              {showResults &&
                DispFields &&
                DispFields.Color !== undefined &&
                (() => {
                  const colorObject = getReviewColors(DispFields.Color);

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>{DispFields?.YourAnswer || "N/A"} </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>{DispFields?.CorrectAnswer || "N/A"} </span>
                      </div>
                      <div
                        className={`${
                          DispFields.Points == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          DispFields.Points == 0 ? testRedText : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>{((DispFields.Points || 0) / 4) * 100}%</span>
                      </div>
                    </div>
                  );
                })()}
              {/* Show Answer mode Disp fields */}
              {isShowAnswerMode &&
                showAnswerData?.Disp &&
                (() => {
                  const colorObject = getReviewColors(
                    showAnswerData.Disp.Color
                  );

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>{showAnswerData.Disp?.YourAnswer || "N/A"} </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>
                          {showAnswerData.Disp?.CorrectAnswer || "N/A"}{" "}
                        </span>
                      </div>
                      <div
                        className={`${
                          (showAnswerData.Disp?.Points || 0) == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          (showAnswerData.Disp?.Points || 0) == 0
                            ? testRedText
                            : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>
                          {((showAnswerData.Disp?.Points || 0) / 4) * 100}%
                        </span>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </div>
          <div className={styles.sigField}>
            <div className={styles.sigColumn}>
              <span className={styles.fieldLabel}>
                Sig.:
              </span>
              {!showResults && !isShowAnswerMode && (
                <input
                  type="text"
                  id="sig"
                  name="sig"
                  className={styles.sigInput}
                  value={currentPerscription?.sig || ""}
                  onChange={(e) => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      return;
                    }
                    handleInputChange("sig", e.target.value);
                  }}
                  onClick={() => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      toast(
                        "You've already viewed the answer for this question"
                      );
                    }
                  }}
                />
              )}
              {/* Review mode Sig fields */}
              {showResults && SigFields && (
                <div className={styles.resultRow}>
                  <div className={styles.resultCard}>
                    <div
                      className={`${testgrayBackground} ${testgrayText} ${styles.column}`}
                    >
                      <span className={styles.bold}>Component Results </span>
                      {Object.entries(SigFields?.ComponentResults || {}).map(
                        ([key, value]) => (
                          <div
                            key={key}
                            className={`${
                              value == false
                                ? testRedBackground
                                : testgreenBackground
                            } ${value == false ? testRedText : testgreenText}`}
                          >
                            <span className={styles.bold}>
                              {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                            </span>
                            <span>{value ? "Correct" : "Incorrect"}</span>
                          </div>
                        )
                      )}
                    </div>
                    <div
                      className={`${
                        (SigFields.Points || 0) == 0
                          ? testRedBackground
                          : testgreenBackground
                      } ${
                        (SigFields.Points || 0) == 0
                          ? testRedText
                          : testgreenText
                      }`}
                    >
                      <span className={styles.bold}>Percentage of Total: </span>
                      <span>{((SigFields.Points || 0) / 4) * 100}%</span>
                    </div>
                  </div>
                  <div className={styles.resultCard}>
                    <div
                      className={`${testgrayBackground} ${testgrayText} ${styles.column}`}
                    >
                      <span className={styles.bold}>Feedback </span>
                      {(SigFields?.Feedback || []).map((feedback, index) => (
                        <div
                          key={index}
                          className={`${
                            feedback.includes("Incorrect")
                              ? testRedBackground
                              : testgreenBackground
                          } ${
                            feedback.includes("Incorrect")
                              ? testRedText
                              : testgreenText
                          }`}
                        >
                          <span className={styles.bold}>{feedback}</span>
                        </div>
                      ))}
                      {(SigFields?.Feedback?.length == 0 ||
                        !SigFields?.Feedback) && (
                        <div
                          className={`${testgreenText} ${testgreenBackground}`}
                        >
                          <span className={styles.bold}>
                            You have entered everything correctly
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* Show Answer mode Sig fields */}
              {isShowAnswerMode && showAnswerData?.Sig && (
                <div className={styles.resultRow}>
                  <div className={styles.resultCard}>
                    <div
                      className={`${testgrayBackground} ${testgrayText} ${styles.column}`}
                    >
                      <span className={styles.bold}>Component Results </span>
                      {Object.entries(
                        showAnswerData.Sig?.ComponentResults || {}
                      ).map(([key, value]) => (
                        <div
                          key={key}
                          className={`${
                            value == false
                              ? testRedBackground
                              : testgreenBackground
                          } ${value == false ? testRedText : testgreenText}`}
                        >
                          <span className={styles.bold}>
                            {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                          </span>
                          <span>{value ? "Correct" : "Incorrect"}</span>
                        </div>
                      ))}
                    </div>
                    <div
                      className={`${
                        (showAnswerData.Sig?.Points || 0) == 0
                          ? testRedBackground
                          : testgreenBackground
                      } ${
                        (showAnswerData.Sig?.Points || 0) == 0
                          ? testRedText
                          : testgreenText
                      }`}
                    >
                      <span className={styles.bold}>Percentage of Total: </span>
                      <span>
                        {((showAnswerData.Sig?.Points || 0) / 4) * 100}%
                      </span>
                    </div>
                  </div>
                  <div className={styles.resultCard}>
                    <div
                      className={`${testgrayBackground} ${testgrayText} ${styles.column}`}
                    >
                      <span className={styles.bold}>Feedback </span>
                      {(showAnswerData.Sig?.Feedback || []).map(
                        (feedback, index) => (
                          <div
                            key={index}
                            className={`${
                              feedback.includes("Incorrect")
                                ? testRedBackground
                                : testgreenBackground
                            } ${
                              feedback.includes("Incorrect")
                                ? testRedText
                                : testgreenText
                            }`}
                          >
                            <span className={styles.bold}>{feedback}</span>
                          </div>
                        )
                      )}
                      {(showAnswerData.Sig?.Feedback?.length == 0 ||
                        !showAnswerData.Sig?.Feedback) && (
                        <div
                          className={`${testgreenText} ${testgreenBackground}`}
                        >
                          <span className={styles.bold}>
                            You have entered everything correctly
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.lastField}>
            <div className={styles.fieldLabelRow}>
              <span className={styles.fieldLabel}>
                Repeat
              </span>
              {!showResults && !isShowAnswerMode && (
                <input
                  type="number"
                  id="repeat"
                  name="repeat"
                  placeholder="0"
                  min={0}
                  className={styles.numberInput}
                  value={currentPerscription?.repeat || ""}
                  onChange={(e) => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      return;
                    }
                    // Convert to integer for repeat field
                    const intValue =
                      e.target.value === "" ? 0 : parseInt(e.target.value, 10);
                    handleInputChange("repeat", intValue);
                  }}
                  onClick={() => {
                    if (
                      examinationState.tutorialMode.includes(currentQuestionId)
                    ) {
                      toast(
                        "You've already viewed the answer for this question"
                      );
                    }
                  }}
                />
              )}
              {!showResults && !isShowAnswerMode && (
                <span>times</span>
              )}
              {/* Review mode Repeat fields */}
              {showResults &&
                RepeatFields &&
                RepeatFields.Color !== undefined &&
                (() => {
                  const colorObject = getReviewColors(RepeatFields.Color);

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>{RepeatFields?.YourAnswer || "N/A"} </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>{RepeatFields?.CorrectAnswer || "N/A"} </span>
                      </div>
                      <div
                        className={`${
                          RepeatFields.Points == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          RepeatFields.Points == 0 ? testRedText : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>{((RepeatFields.Points || 0) / 4) * 100}%</span>
                      </div>
                    </div>
                  );
                })()}
              {/* Show Answer mode Repeat fields */}
              {isShowAnswerMode &&
                showAnswerData?.Repeat &&
                (() => {
                  const colorObject = getReviewColors(
                    showAnswerData.Repeat.Color
                  );

                  return (
                    <div className={styles.resultCard}>
                      <div
                        className={`${colorObject.colorString} ${colorObject.textString}`}
                      >
                        <span className={styles.bold}>Your Answer: </span>
                        <span>
                          {showAnswerData.Repeat?.YourAnswer || "N/A"}{" "}
                        </span>
                      </div>
                      <div
                        className={`${testgreenBackground} ${testgreenText}`}
                      >
                        <span className={styles.bold}>Correct Answer: </span>
                        <span>
                          {showAnswerData.Repeat?.CorrectAnswer || "N/A"}{" "}
                        </span>
                      </div>
                      <div
                        className={`${
                          (showAnswerData.Repeat?.Points || 0) == 0
                            ? testRedBackground
                            : testgreenBackground
                        } ${
                          (showAnswerData.Repeat?.Points || 0) == 0
                            ? testRedText
                            : testgreenText
                        }`}
                      >
                        <span className={styles.bold}>Percentage of Total: </span>
                        <span>
                          {((showAnswerData.Repeat?.Points || 0) / 4) * 100}%
                        </span>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerscriptionAnswerBlock;
